import { Component, OnInit, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from 'ng2-translate/ng2-translate';

import { UserRole } from '../../../domain/enums/userRole';
import { HeaderService } from './header.service';
import { TotalUserQuota } from '../../../domain/models/TotalUserQuota';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() userRoles: UserRole[] = [];
  @Input() userName = '';
  @Input() impersonated = false;
  @Output() onNavigate = new EventEmitter<string>();
  @Output() onLanguageChanged = new EventEmitter<string>();

  private quota: TotalUserQuota;

  constructor(private router: Router,
    private zone: NgZone,
    private headerService: HeaderService,
    private translateService: TranslateService) { }

  ngOnInit() {
    this.zone.run(() => {
      this.headerService.getOauthInstance().subscribe((oauth: any) => {
        if (oauth) {
          if (!oauth.isSignedIn.get()) {
            // this.router.navigate(['']);
          } else {
            let currentUser = oauth.currentUser.get();
            let profile = currentUser.getBasicProfile();
          }
        }
      });
    });
    this.getAvailableUserQuota();
  }

  onOverviewSelected(): void {
    this.onNavigate.emit('overview');
    this.getAvailableUserQuota();
  }

  onNewRouteSelected(): void {
    this.onNavigate.emit('new');
    this.getAvailableUserQuota();
  }

  onProjectsSelected(): void {
    this.onNavigate.emit('projects');
    this.getAvailableUserQuota();
  }

  onDashboardsSelected(): void {
    this.onNavigate.emit('dashboards');
    this.getAvailableUserQuota();
  }

  goToAdminPage(): void {
    this.onNavigate.emit('admin');
  }

  routeActive(route: string): boolean {
    return this.router.isActive('/auth' + route, true);
  }

  signOut(): void {
    this.zone.run(() => {
      this.headerService.getOauthInstance().subscribe((oauth: any) => {
        if (oauth) {
          oauth.signOut().then(() => {
            this.router.navigate(['']);
          });
        }
      });
    });
  }

  hideNavigation(): boolean {
    return this.router.url.indexOf('route-detail') !== -1;
  }

  languageChanged(language: string): void {
    if (this.translateService.currentLang !== language) {
      this.zone.run(() => {
        this.translateService.use(language);
        this.onLanguageChanged.emit(language);
      });
    }
  }

  isSuperAdmin(): boolean {
    return this.userRoles.includes(UserRole.SuperAdmin);
  }
  isReadOnly(): boolean {
    return this.userRoles.includes(UserRole.ReadOnly);
  }

  isImpersonated(): boolean {
    return this.impersonated;
  }

  isChosenLanguage(language: string): boolean {
    return language === this.translateService.currentLang;
  }

  getAvailableUserQuota(): void {
    this.headerService.getTotalQuota().subscribe((result: TotalUserQuota) => {
      this.quota = result;
    });
  }

  usesCredits(): boolean {
    return this.quota !== undefined && this.quota.totalQuota > -1;
  }

  usesCustomApiKey(): boolean {
    return this.quota !== undefined && this.quota.totalQuota === -1;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/header/header.component.ts